function normalizeLineBreaks(str, lineEnd = "\n") {
  return str.replace(/\r\n/g, lineEnd).replace(/\r/g, lineEnd).replace(/\n/g, lineEnd);
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  normalizeLineBreaks
};
//# sourceMappingURL=normalizeLineBreaks.js.map
